import React from 'react';

import useIsInsideApp from 'hooks/useIsInsideApp';

import { Container, Content, Button, Logo } from './styles';

interface HeaderProps {
  openMenu: () => void;
  goBack: () => void;
}

const Header = ({ openMenu, goBack }: HeaderProps) => {
  const isInsideApp = useIsInsideApp();

  return (
    <Container>
      <Content>
        {isInsideApp && (
          <Button onClick={goBack}>
            <img alt="back" src="/images/back-arrow.svg" width={12} />
          </Button>
        )}
        <Logo src="/images/logo-rappi-travel4business.svg" />
        <Button onClick={openMenu}>
          <img alt="menu" src="/images/menu.svg" />
        </Button>
      </Content>
    </Container>
  );
};

export default Header;
